module.exports = __webpack_public_path__ + "img/3564d10.jpg";